import { useContext, useEffect, useState } from "react";
import { Label, TextInput, Button, Textarea } from "flowbite-react";
import { useForm, Controller } from "react-hook-form";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaFormatosGeneralesInterface } from "../../../../../interfaces/FechaFormatosGeneralesInterface";
import { FichaIdentificacionInterface } from "../../../../../interfaces/FichaIdentificacionInterface";
import { Loading } from "../../../../../components/Loading/Loading";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";
import { useParams, useNavigate } from "react-router-dom";
import { API } from "../../../../../global/global";
import Header from "../../../../../components/HeaderForms/HeaderForms";

export const FichaIdentificacionEditarScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario = "DATOS GENERALES";
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const { reset, handleSubmit, control } = useForm();
  const [edad, setEdad] = useState<number | null>(null);
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);
  const { uuid } = useParams<{ uuid: string }>();
  const navigate = useNavigate();

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFechaFG = useGetData<FechaFormatosGeneralesInterface>({
    url: `/fecha_formatosgenerales/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha_formatosgenerales"],
  });

  const mutateFechaFG = useMutationData({
    url: `/fecha_formatosgenerales/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha_formatosgenerales"],
  });

  const queryFicha = useGetData<FichaIdentificacionInterface>({
    url: `/ficha_identificacion/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "ficha_identificacion"],
  });

  const mutateFicha = useMutationData({
    url: `/ficha_identificacion/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "ficha_identificacion"],
  });

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }
    return edadCalculada;
  };

  const normalizeString = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const nombreCompleto = normalizeString(
    `${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}`.replace(
      /\s/g,
      "_"
    )
  );

  useEffect(() => {
    if (queryEvaluado.data) {
      const nuevaEdad = calcularEdad(queryEvaluado.data.fecha_nacimiento || "");
      setEdad(nuevaEdad);
      reset(queryEvaluado.data);
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (queryFechaFG.data) {
      const fechafg = queryFechaFG.data;
      reset({
        ...queryEvaluado.data,
        fecha_ficha_ident: fechafg.fecha_ficha_ident || "",
      });
    }
  }, [queryFechaFG.data, reset, queryEvaluado.data]);

  useEffect(() => {
    if (queryFicha.data) {
      const fichafg = queryFicha.data;
      reset({
        ...queryEvaluado.data,
        cicatrices: fichafg.cicatrices || "",
        lunares: fichafg.lunares || "",
        defecto_fisico: fichafg.defecto_fisico || "",
        tatuajes: fichafg.tatuajes || "",
        perdida_miembro: fichafg.perdida_miembro || "",
        deteccion_riesgo_ficha: fichafg.deteccion_riesgo_ficha || "",
      });
    }
  }, [queryFicha.data, reset, queryEvaluado.data]);

  useEffect(() => {
    if (evaluadosList_id) {
      const token = localStorage.getItem("token");
      fetch(`${API}/evaluados/${evaluadosList_id}/photo/${nombreCompleto}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.url) {
            setPhotoUrl(data.url);
            console.log("URL de la foto:", data.url);
          } else {
            setPhotoUrl(null);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la URL de la foto:", error);
          setPhotoUrl(null);
        });
    }
  }, [evaluadosList_id, nombreCompleto]);

  if (queryEvaluado.isLoading) {
    return <Loading />;
  }

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className={`max-w-4xl mx-auto shadow-lg rounded-lg overflow-hidden mt-4 mb-4 relative div-ignore ${isDarkMode ? "bg-gray-800 text-white" : "bg-white text-gray-800"}`}>
        <form
          onSubmit={handleSubmit((data) => {
            console.log(data);
            const formData = {
              ...data,
            };
            mutateFechaFG.mutate(
              {
                data: { fecha_ficha_ident: data.fecha_ficha_ident },
                tipo: "put",
              },
              {
                onSuccess: () => {
                  console.log("Fecha de Formatos Generales guardada con éxito");
                },
                onError: (error) => {
                  console.error(
                    "Error al guardar Fecha de Formatos Generales:",
                    error
                  );
                },
              }
            );
            mutateFicha.mutate(
              {
                data: formData,
                tipo: "put",
              },
              {
                onSuccess: () => {
                  console.log("Ficha guardada con éxito");
                  navigate(`/formatosG/${evaluadosList_id}`);
                  window.scrollTo(0, 0);
                },
                onError: (error) => {
                  console.error("Error al guardar Ficha:", error);
                },
              }
            );
          })}
          className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800" : "bg-white"}`}
        >
          {/* Marca de agua */}
          <div className="absolute inset-0 flex justify-center items-center pointer-events-none z-0">
            <div
              className={`text-9xl font-bold transform rotate-[-45deg] ${isDarkMode ? "text-blue-700" : "text-blue-500"}`}
              style={{ opacity: 0.2 }}
            >
              CONFIDENCIAL
            </div>
          </div>

          {/* Header */}
          <Header titulo={tituloFormulario} />

          {/* Contenido del formulario */}
          <div className="p-6 grid">
            {/* Left Column - Form Fields */}
            <div className="col-span-2 space-y-4">
              {/* Grupo de Empresa, Puesto y Fecha de Ingreso */}
              <div className="space-y-4">
                <div className="flex justify-between items-center">
                  <Label htmlFor="puesto" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    FECHA DE EVALUACION:
                  </Label>
                  <Controller
                    name="fecha_ficha_ident"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="fecha_ficha_ident"
                        type="date"
                        value={
                          field.value ||
                          queryFechaFG.data?.fecha_ficha_ident ||
                          ""
                        }
                        onChange={(e) => field.onChange(e.target.value)}
                        className={`flex-1 ml-4 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                      />
                    )}
                  />
                </div>

                <div className="flex justify-center items-center">
                  <Label htmlFor="empresa" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    EMPRESA A LA QUE SE POSTULA Y EMPRESA PARA LA QUE LABORA:
                  </Label>
                  <TextInput
                    id="empresa"
                    name="empresa"
                    value={`${queryEvaluado.data?.empresa_id?.nombre || ""} ${
                      queryEvaluado.data?.empresa_labora
                        ? "y " + queryEvaluado.data.empresa_labora
                        : ""
                    }`}
                    className={`flex-1 ml-4 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                    disabled
                  />
                </div>

                <div className="flex justify-center items-center">
                  <Label htmlFor="empresa" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    ¿SE POSTULA O EVALÚA?
                  </Label>
                  <TextInput
                    id="nombre_hijo5"
                    name="nombre_hijo5"
                    value={`${queryEvaluado.data?.nombre_hijo5 || ""} `}
                    disabled
                    className={`flex-1 ml-4 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                  />
                </div>

                <div className="flex justify-between items-center">
                  <Label htmlFor="puesto" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    PUESTO:
                  </Label>
                  <TextInput
                    id="puesto"
                    name="puesto"
                    value={queryEvaluado.data?.puesto || ""}
                    disabled
                    className={`flex-1 ml-4 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                  />
                </div>

                <div className="flex justify-between items-center">
                  <Label htmlFor="fecha" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    FECHA DE INGRESO Y ANTIGÜEDAD:
                  </Label>
                  <TextInput
                    id="fecha"
                    type="text"
                    value={`Ingresó el ${
                      queryEvaluado.data?.fecha_ingreso
                        ? new Date(
                            queryEvaluado.data.fecha_ingreso
                          ).toLocaleDateString("es-ES")
                        : ""
                    } y tiene ${
                      queryEvaluado.data?.antiguedad || ""
                    } años de antigüedad`}
                    disabled
                    className={`flex-1 ml-4 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                  />
                </div>
              </div>

              {/* Barra separadora */}
              <div className={`p-2 rounded-t-lg z-10 relative ${isDarkMode ? "bg-blue-700 text-white" : "bg-customBlue text-white"}`}>
                <h2 className="font-bold text-lg">DATOS GENERALES</h2>
              </div>

              <div className="grid grid-cols-3 gap-4">
                {/* NOMBRE COMPLETO */}
                <div className="flex flex-col col-span-2">
                  <div className="flex flex-col mb-4">
                    <Label htmlFor="nombre" className={`font-semibold text-left ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                      NOMBRE COMPLETO:
                    </Label>
                    <TextInput
                      id="nombre"
                      name="nombre"
                      value={`${queryEvaluado.data?.nombre || ""} ${
                        queryEvaluado.data?.apellido_paterno || ""
                      } ${queryEvaluado.data?.apellido_materno || ""}`}
                      disabled
                      className={`w-full ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                    />
                  </div>

                  {/* Fecha de Nacimiento */}
                  <div className="flex flex-col mb-4">
                    <Label htmlFor="fechaNac" className={`font-semibold text-left ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                      FECHA DE NACIMIENTO:
                    </Label>
                    <TextInput
                      id="fechaNac"
                      value={queryEvaluado.data?.fecha_nacimiento || ""}
                      disabled
                      type="date"
                      className={`w-full ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                    />
                  </div>

                  {/* Lugar de Nacimiento */}
                  <div className="flex flex-col mb-4">
                    <Label htmlFor="lugarNac" className={`font-semibold text-left ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                      LUGAR DE NACIMIENTO:
                    </Label>
                    <TextInput
                      id="lugarNac"
                      value={queryEvaluado.data?.lugar_nacimiento || ""}
                      disabled
                      className={`w-full ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                    />
                  </div>

                  {/* Nacionalidad */}
                  <div className="flex flex-col mb-4">
                    <Label
                      htmlFor="nacionalidad"
                      className={`font-semibold text-left ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
                    >
                      NACIONALIDAD:
                    </Label>
                    <TextInput
                      id="nacionalidad"
                      value={queryEvaluado.data?.nacionalidad || ""}
                      disabled
                      className={`w-full ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                    />
                  </div>
                </div>

                {/* FOTO */}
                <div className={`w-64 h-64 border rounded-md overflow-hidden flex items-center justify-center mt-4 relative z-10 ${isDarkMode ? "border-gray-600 bg-gray-700" : "border-gray-300 bg-gray-100"}`}>
                  {photoUrl ? (
                    <img
                      src={photoUrl}
                      alt="Foto de evaluado"
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <span className={`text-gray-500 ${isDarkMode ? "text-gray-400" : ""}`}>Sin foto disponible</span>
                  )}
                </div>
              </div>

              {/* CURP y RFC */}
              <div className="flex space-x-4 w-full">
                <div className="flex flex-col flex-1">
                  <Label htmlFor="curp" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    CURP:
                  </Label>
                  <TextInput
                    id="curp"
                    value={queryEvaluado.data?.curp || ""}
                    disabled
                    className={`w-full ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                  />
                </div>
                <div className="flex flex-col flex-1">
                  <Label htmlFor="rfc" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    RFC:
                  </Label>
                  <TextInput
                    id="rfc"
                    value={queryEvaluado.data?.rfc || ""}
                    disabled
                    className={`w-full ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                  />
                </div>
              </div>

              {/* ULTIMO GRADO DE ESTUDIOS y DOMICILIO PARTICULAR en una misma fila */}
              <div className="flex space-x-4 w-full">
                <div className="flex flex-col flex-[1]">
                  <Label htmlFor="gradoEstudios" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    ULTIMO GRADO DE ESTUDIOS:
                  </Label>
                  <TextInput
                    id="gradoEstudios"
                    value={queryEvaluado.data?.escolaridad || ""}
                    disabled
                    className={`w-full ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                  />
                </div>
                <div className="flex flex-col flex-[3]">
                  <Label htmlFor="domicilio" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    DOMICILIO PARTICULAR:
                  </Label>
                  <TextInput
                    id="domicilio"
                    value={`${queryEvaluado.data?.calle || ""}, ${
                      queryEvaluado.data?.numero_exterior || ""
                    }, ${queryEvaluado.data?.numero_interior || ""}, ${
                      queryEvaluado.data?.colonia || ""
                    }, ${queryEvaluado.data?.codigo_postal || ""}, ${
                      queryEvaluado.data?.municipio || ""
                    }, ${queryEvaluado.data?.estado || ""}, ${
                      queryEvaluado.data?.pais || ""
                    }`}
                    disabled
                    className={`w-full ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                  />
                </div>
              </div>

              {/* CIUDAD DEL DOMICILIO DONDE VIVE Y CUANTOS AÑOS TIENE VIVIENDO EN ESE DOMICILIO */}
              <div className="flex space-x-4 w-full">
                <div className="flex flex-col flex-1">
                  <Label htmlFor="Ciudad" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    CIUDAD DEL DOMICILIO DONDE VIVE:
                  </Label>
                  <TextInput
                    id="Ciudad"
                    value={queryEvaluado.data?.estado || ""}
                    disabled
                    className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                  />
                </div>
                <div className="flex flex-col flex-1">
                  <Label htmlFor="Años viviendo" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    CUANTOS AÑOS TIENE VIVIENDO EN ESE DOMICILIO:
                  </Label>
                  <Textarea
                    id="Años viviendo"
                    value={queryEvaluado.data?.anios_domicilio_viviendo || ""}
                    rows={5}
                    disabled
                    className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                  />
                </div>
              </div>

              {/* CON QUIEN VIVE Y TELEFONO Y TELEFONO PARA RECADOS */}
              <div className="flex space-x-4 w-full">
                <div className="flex flex-col flex-1">
                  <Label htmlFor="Con quien" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    CON QUIEN VIVE:
                  </Label>
                  <TextInput
                    id="Con quien"
                    value={queryEvaluado.data?.vive_con}
                    disabled
                    className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                  />
                </div>
                <div className="flex flex-col flex-1">
                  <Label htmlFor="telefono" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    TELEFONO Y TELEFONO PARA RECADOS:
                  </Label>
                  <Textarea
                    id="telefono"
                    value={`(${queryEvaluado.data?.telefono || ""})  (${
                      queryEvaluado.data?.telefono_recados || ""
                    })`}
                    rows={5}
                    disabled
                    className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                  />
                </div>
              </div>

              {/* CORREO ELECTRÓNICO Y ESTADO CIVIL */}
              <div className="flex space-x-4 w-full">
                <div className="flex flex-col flex-1">
                  <Label htmlFor="correo" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    CORREO ELECTRÓNICO:
                  </Label>
                  <TextInput
                    id="correo"
                    value={queryEvaluado.data?.correo}
                    disabled
                    className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                  />
                </div>
                <div className="flex flex-col flex-1">
                  <Label htmlFor="estado civil" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    ESTADO CIVIL:
                  </Label>
                  <TextInput
                    id="estado civil"
                    value={queryEvaluado.data?.estado_civil}
                    disabled
                    className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                  />
                </div>
              </div>

              {/* TIEMPO DE CASADO(A) Y/0 CONCUBINATO Y A QUE SE DEDICA SU ESPOSA(O) Y/O CONCUBINO */}
              <div className="flex space-x-4 w-full">
                <div className="flex flex-col flex-1">
                  <Label htmlFor="tiempo casado" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    TIEMPO DE CASADO(A) Y/0 CONCUBINATO:
                  </Label>
                  <TextInput
                    id="tiempo casado"
                    value={queryEvaluado.data?.tiempo_casado}
                    disabled
                    className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                  />
                </div>
                <div className="flex flex-col flex-1">
                  <Label htmlFor="ocupacion conyugue" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    A QUE SE DEDICA SU ESPOSA(O) Y/O CONCUBINA(O):
                  </Label>
                  <TextInput
                    id="ocupacion conyugue"
                    value={queryEvaluado.data?.conyuge_oficio}
                    disabled
                    className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                  />
                </div>
              </div>

              {/* NOMBRE DE ESPOSA(O) Y/O CONCUBINO Y CUANTOS HIJOS TIENE */}
              <div className="flex space-x-4 w-full">
                <div className="flex flex-col flex-1">
                  <Label htmlFor="nombre esposa" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    NOMBRE DE ESPOSA(O) Y/O CONCUBINA(O):
                  </Label>
                  <TextInput
                    id="nombre esposa"
                    value={queryEvaluado.data?.nombre_conyuge}
                    disabled
                    className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                  />
                </div>
                <div className="flex flex-col flex-1">
                  <Label htmlFor="hijos" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    CUANTOS HIJOS TIENE:
                  </Label>
                  <TextInput
                    id="hijos"
                    value={queryEvaluado.data?.cuantos_hijos}
                    disabled
                    className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                  />
                </div>
              </div>

              {/* NOMBRE Y EDADES DE LOS HIJOS Y CICATRICES Y LUNARES */}
              <div className="flex space-x-4 w-full">
                <div className="flex flex-col flex-1">
                  <Label htmlFor="nombre hijos" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    NOMBRE Y EDADES DE LOS HIJOS:
                  </Label>
                  <TextInput
                    id="nombre hijos"
                    value={`${queryEvaluado.data?.nombre_hijo1 || ""}, ${
                      queryEvaluado.data?.edad_hijo1 || ""
                    } años`}
                    disabled
                    className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                  />
                </div>
                <div className="flex flex-col flex-1">
                  <Label htmlFor="cicatricres" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    CICATRICES, LUNARES:
                  </Label>
                  <Controller
                    name="cicatrices"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="cicatrices"
                        type="text"
                        value={field.value || queryFicha.data?.cicatrices || ""}
                        onChange={(e) => field.onChange(e.target.value)}
                        placeholder="Cicatrices"
                        className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                      />
                    )}
                  />
                  <Controller
                    name="lunares"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="lunares"
                        type="text"
                        value={field.value || queryFicha.data?.lunares || ""}
                        onChange={(e) => field.onChange(e.target.value)}
                        className={`mt-2 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                        placeholder="Lunares"
                      />
                    )}
                  />
                </div>
              </div>

              {/* DEFECTO FISICO Y TATUAJES */}
              <div className="flex space-x-4 w-full">
                <div className="flex flex-col flex-1">
                  <Label htmlFor="defecto_fisico" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    ALGÚN DEFECTO FÍSICO:
                  </Label>
                  <Controller
                    name="defecto_fisico"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="defecto_fisico"
                        type="text"
                        value={
                          field.value || queryFicha.data?.defecto_fisico || ""
                        }
                        onChange={(e) => field.onChange(e.target.value)}
                        placeholder="Defecto..."
                        className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                      />
                    )}
                  />
                </div>
                <div className="flex flex-col flex-1">
                  <Label htmlFor="tatuajes" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    TATUAJES:
                  </Label>
                  <Controller
                    name="tatuajes"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="tatuajes"
                        type="text"
                        value={field.value || queryFicha.data?.tatuajes || ""}
                        onChange={(e) => field.onChange(e.target.value)}
                        placeholder="Tatuajes"
                        className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                      />
                    )}
                  />
                </div>
              </div>
              {/* PERDIDA DE ALGÚN MIEMBRO */}
              <div className="flex space-x-4 w-full">
                <div className="flex flex-col flex-1">
                  <Label htmlFor="perdida_miembro" className={`font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                    PERDIDA DE ALGÚN MIEMBRO:
                  </Label>
                  <Controller
                    name="perdida_miembro"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="perdida_miembro"
                        type="text"
                        value={
                          field.value || queryFicha.data?.perdida_miembro || ""
                        }
                        onChange={(e) => field.onChange(e.target.value)}
                        placeholder="¿Tuvó perdida?"
                        className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                      />
                    )}
                  />
                  <Label
                    htmlFor="deteccion_riesgo_ficha"
                    className={`font-semibold mt-2 ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
                  >
                    DETECCIÓN DE RIESGO:
                  </Label>
                  <Controller
                    name="deteccion_riesgo_ficha"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextInput
                        id="deteccion_riesgo_ficha"
                        type="text"
                        value={
                          field.value ||
                          queryFicha.data?.deteccion_riesgo_ficha ||
                          ""
                        }
                        className={`mt-2 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : ""}`}
                        onChange={(e) => field.onChange(e.target.value)}
                        placeholder="Riesgo..."
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Botones */}
          <div className="mt-4 mb-4 px-4">
            <div className="flex justify-between">
              <Button
                color="red"
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(-1);
                }}
                className={`bg-red-500 hover:bg-red-600 text-white dark:bg-red-600 dark:hover:bg-red-700`}
              >
                Regresar
              </Button>
              <button
                type="submit"
                className={`rounded px-4 py-2 z-10 ${isDarkMode ? "bg-green-600 hover:bg-green-700 text-white" : "bg-green-500 hover:bg-green-600 text-white"}`}
              >
                {" "}
                Guardar{" "}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};